<script>
import router from "../../router";
export default {
  name: "AddModifier",
  data() {
    return {
      storeList: [],
      selectedStores: [],
      isAll: false,
      availableStoreStr: "",
      stores: [],
      modifier: {
        id: null,
        name: "",
        modifier_options: []
      }
    };
  },
  methods: {
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    checkAllStores(event) {
      this.selectedStores = [];
      this.availableStoreStr = "";

      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores.push(this.storeList[i].id);
        }
      }
      this.setAvailableStr();
    },

    setAvailableStr() {
      this.availableStoreStr = "";
      if (this.selectedStores.length > 0) {
        if (this.selectedStores.length == this.storeList.length) {
          this.isAll = true;
          this.availableStoreStr = "Available in all stores";
        } else {
          this.isAll = false;
          if (this.selectedStores.length == 1) {
            this.availableStoreStr = "Available in 1 store";
          } else {
            this.availableStoreStr =
              "Available in " + this.selectedStores.length + " store";
          }
        }
      }
    },
    validateFilledValues(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == "modifier-form") {
            if (!this.modifier.modifier_options) {
              this.modifier.modifier_options = [];
            }
            var option = {
              name: "",
              price: ""
            };
            this.modifier.modifier_options.push(option);
          }
          return;
        }
      });
    },
    details(id) {
      this.modifier = {};

      this.$api
        .getAPI({
          _action: "/modifier/detail/" + id
        })
        .then(res => {
          this.modifier = res;
          if (res.modifier_options == null || res.modifier_options.length < 1) {
            this.modifier.modifier_options = [];
          }

          if (res.stores && res.stores.length > 0) {
            for (var i = 0; i < res.stores.length; i++) {
              this.selectedStores.push(res.stores[i].store_id);
            }

            if (this.selectedStores.length == this.storeList.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }
          this.setAvailableStr();
        });
    },
    save() {
      if (this.selectedStores.length > 0) {
        this.modifier.stores = this.selectedStores;
      } else {
        this.modifier.stores = [];
      }

      this.$api
        .postAPI({
          _action: "/modifier/",
          _body: this.modifier,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/modifier");
        })
        .catch(e => {});
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },
    deleteModifier(index) {
      this.modifier.modifier_options.splice(index, 1);
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
          if (this.$route.params.id) {
            this.details(this.$route.params.id);
          } else {
            this.isAll = true;
            this.checkAllStores();
            var optons = {
              name: "",
              price: ""
            };
            this.modifier.modifier_options.push(optons);
          }
        })
        .catch(e => {});
    }
  },
  mounted() {
    this.getStoreList();
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row mb-3">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label><span style="color:#ff0000"> *</span>
                  <input
                    name="name"
                    v-model="modifier.name"
                    v-validate="'required|max:300'"
                    class="form-control" maxlength="300"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>
              </div>
              <form data-vv-scope="modifier-form">
                <div
                  class="row mb-2 border border-secondary px-2 pt-2"
                  v-for="(modifier_options, index) in modifier.modifier_options"
                  :key="modifier_options.id"
                >
                  <div class="col-lg-6 mb-lg-3 mb-4">
                    <label for>{{$lang.messages.option_name}}</label>
                    <input
                      :id="'name_'  +index"
                      :name="'name_'  +index"
                      v-model="modifier_options.name"
                      v-validate="'required'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('modifier-form.name_'  +index) }"
                      type="text"
                    />
                    <i v-show="errors.has('modifier-form.name_'  +index)" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('modifier-form.name_'  +index)"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_unique_option_name}}</span>
                  </div>

                  <div class="col-lg-5 col-9">
                    <label for>{{$lang.messages.price}}</label>
                    <input
                      :id="'price_'  +index"
                      :name="'price_'  +index"
                      type="text"
                      class="form-control"
                      placeholder="0.00"
                      v-model="modifier_options.price"
                      v-validate="'decimal'"
                      :class="{'input': true, 'is-danger': errors.has('modifier-form.price_'  +index) }"
                    />
                    <i v-show="errors.has('modifier-form.price_'  +index)" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('modifier-form.price_'  +index)"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_price}}</span>
                  </div>

                  <div class="col-sm-1 text-right text-lg-left">
                    <a
                      href="javascript:void(0)"
                      class="text-grey font-18 ml-3"
                      @click="deleteModifier(index)"
                    >
                      <i class="far fa-trash-alt font-18 text-danger" style="padding-top: 40px;"></i>
                    </a>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-lg-12 col-12">
                    <a
                      href="javascript:void(0)"
                      @click="validateFilledValues('modifier-form')"
                      class="text-primary"
                    >
                      <i class="fas fa-plus-circle font-18 mr-2"></i>
                      {{$lang.messages.add_option}}
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 pt-1 border">
            <div
              class="card-header bg-white border-bottom cursor-pointer py-3 px-lg-5 px-4"
              data-toggle="collapse"
              data-target=".stores-list"
              aria-expanded="false"
              aria-controls="multiCollapseExample1 multiCollapseExample2"
            >
              <h4 class="font-20 d-inline">
                {{$lang.messages.store}}
                <span
                  class="font-16 text-secondary ml-3 d-inline"
                >{{availableStoreStr}}</span>
              </h4>
              <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
            </div>
            <div class="card-body form-style collapse stores-list px-lg-5 px-4 py-lg-5 py-4">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="checkbox-1"
                  v-model="isAll"
                  @change="checkAllStores($event)"
                />
                <label
                  class="custom-control-label text-dark ml-2"
                  for="checkbox-1"
                >{{$lang.messages.available_in_all_stores}}</label>
              </div>
              <div>
                <div
                  class="custom-control custom-checkbox mb-3 ml-3"
                  v-for="store in storeList"
                  :key="store.id"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :value="store.id"
                    :id="'type_'  +store.id"
                    v-model="selectedStores"
                    @change="checkUncheckStore($event)"
                  />

                  <label
                    class="custom-control-label text-dark ml-2"
                    :for="'type_' +store.id"
                  >{{store.name}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 text-right">
          <button
            type="button"
            class="btn btn-primary mr-3"
            @click="validateForm()"
            id="save-btn"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>